import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'mb-expandable-card-wrapper',
  templateUrl: './expandable-card-wrapper.component.html',
  styleUrls: ['./expandable-card-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableCardWrapperComponent implements AfterViewInit {
  @ViewChild('cardWrapper') cardWrapper!: ElementRef;

  @Input() showAll!: boolean;

  @Output() toggleWrapper = new EventEmitter<boolean>();

  public isExpandable = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    const el = this.cardWrapper.nativeElement;
    this.isExpandable = el.scrollHeight > el.clientHeight || this.showAll;
    this.cdr.detectChanges();
  }

  public setCardWrapperState(): void {
    this.toggleWrapper.emit(!this.showAll);
  }
}
